import React, {useMemo, useReducer, useRef, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import UnderLineInput from '../../../components/input/UnderLineInput'
import Text from '../../../components/text/Text'
import {postUploadImage} from '../../../apis/image/postUploadImage'
import WizButton from '../../../components/button/WizButton'
import DateInput from '../../../components/input/DateInput'
import WizSelectButton from '../../../components/button/WizSelectButton'
import WizSelect from '../../../components/select/WizSelect'
import WizImage from '../../../components/image/WizImage'
import {useTime} from '../../../utils/time'
import useNavigation from '../../../hooks/useNavigation'
import {getValueFromId} from '../../../components/select/constSelect'
import {createLeagueApi} from '../../../apis/league/createLeagueApi'

interface IProps {
    className?: string
}

const initState = {
    names: {ko: '', en: ''},
    thumbnails: {ko: '', en: ''},
    start_at: 0,
    end_at: 0,
    register_by: 0,
    is_active: true,
    start_urls: {ko: '', en: ''},
    rank: 0,
    prize_pools: {ko: '', en: ''},
    icon: '',
    subtitles: {ko: '', en: ''},
    can_join: true,
    autojoin: true,
    promote: true,
    min_balance: '',
    exchange: '',
    meta: {
        theme_color: '#0AAF82',
        banner_pc: '',
        banner_mobile: '',
    },
    show: 0,
}

const LeagueCreatePage: React.FC<IProps> = ({className}) => {
    const {convertInputToTimestamp} = useTime()
    const {goLeagueList} = useNavigation()

    const [state, dispatch] = useReducer(reducer, initState)

    const {
        names,
        thumbnails,
        start_at,
        end_at,
        register_by,
        is_active,
        start_urls,
        rank,
        prize_pools,
        icon,
        subtitles,
        can_join,
        min_balance,
        exchange,
        autojoin,
        promote,
        meta,
        show,
    } = state

    function reducer(state, action) {
        switch (action.type) {
            case 'field_update':
                return {...state, [action.field]: action.value}
        }
        return {...state}
    }

    const thumbnailKoRef = useRef<any>()
    const thumbnailEnRef = useRef<any>()
    const leagueBannerPcRef = useRef<any>()
    const leagueBannerMoRef = useRef<any>()
    const iconImageRef = useRef<any>()
    const onChangeThumbnail = async (e, locale) => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)
            if (locale === 'ko') {
                dispatch({type: 'field_update', field: 'thumbnails', value: {...thumbnails, ko: result?.image_url}})
            } else {
                dispatch({type: 'field_update', field: 'thumbnails', value: {...thumbnails, en: result?.image_url}})
            }
        }
    }

    const onChangeLeagueBanner = async (e, view) => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)
            if (view === 'pc') {
                dispatch({type: 'field_update', field: 'meta', value: {...meta, banner_pc: result?.image_url}})
            } else {
                dispatch({type: 'field_update', field: 'meta', value: {...meta, banner_mobile: result?.image_url}})
            }
        }
    }

    const onChangeIcon = async e => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)
            dispatch({type: 'field_update', field: 'icon', value: result?.image_url})
        }
    }
    const currentList = useMemo(
        () => [
            {id: 'USD', value: 'USD'},
            {id: 'USDT', value: 'USDT'},
            {id: 'BTC', value: 'BTC'},
        ],
        [],
    )

    const themeColorList = useMemo(
        () => [
            {id: '#0AAF82', value: 'Primary'},
            {id: '#FFFFFF', value: 'White'},
            {id: '', value: 'Other'},
        ],
        [],
    )

    const userJoinList = useMemo(
        () => [
            {id: true, value: 'True'},
            {id: false, value: 'False'},
        ],
        [],
    )

    const autoJoinList = useMemo(
        () => [
            {id: true, value: 'Auto'},
            {id: false, value: 'Manual'},
        ],
        [],
    )

    const promotionList = useMemo(
        () => [
            {id: true, value: 'True'},
            {id: false, value: 'False'},
        ],
        [],
    )

    const isActiveList = useMemo(
        () => [
            {id: true, value: 'True'},
            {id: false, value: 'False'},
        ],
        [],
    )

    const [balanceCurrent, setBalanceCurrent] = useState(currentList[0])
    const [themeColor, setThemeColor] = useState(themeColorList[0])

    const onClickCreateLeague = async () => {
        const filter = exchange
            ? {
                  min_balance: `${min_balance} ${balanceCurrent.value}`,
                  exchange: exchange,
              }
            : {
                  min_balance: `${min_balance} ${balanceCurrent.value}`,
              }

        if (!names.ko || !names.en) {
            alert('타이틀이 입력되지 않았습니다.')
            return false
        } else if (!start_at || !end_at || !register_by) {
            alert('시작 일자, 종료 일자, 가입 제한 일자가 입력되지 않았습니다.')
            return false
        } else if (!prize_pools.ko || !prize_pools.en || !min_balance) {
            alert('상금 풀 및 참여 최소 자산이 입력되지 않았습니다.')
            return false
        }

        const createLeagueData = {
            name: names.en,
            names: names,
            thumbnails: thumbnails,
            start_at: convertInputToTimestamp(start_at),
            end_at: convertInputToTimestamp(end_at),
            register_by: convertInputToTimestamp(register_by),
            is_active: is_active,
            start_urls: start_urls,
            rank: Number(rank),
            prize_pools: prize_pools,
            icon: icon,
            subtitles: subtitles,
            can_join: can_join,
            autojoin: autojoin,
            promote: promote,
            filter: filter,
            meta: meta,
            show: show || 0,
        }

        const {data} = await createLeagueApi(createLeagueData)

        if (data) {
            alert('리그 생성에 성공하였습니다.')
            goLeagueList()
        }
    }

    return (
        <PageLayout title={'Create League'}>
            <div
                className={
                    'w-[1000px] bg-white rounded-[10px] shadow-normal mx-auto py-[40px] px-[80px] grid grid-cols-2 gap-x-[40px] gap-y-[60px] lg:w-[900px] md:w-[560px] md:px-[20px] md:text-center sm:block sm:w-full sm:space-y-[30px]'
                }>
                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Title (Korean)</Text>
                    <UnderLineInput
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'names',
                                value: {...names, ko: text},
                            })
                        }
                        inputClassName={'md:text-center'}
                    />
                </div>
                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Title (English)</Text>
                    <UnderLineInput
                        inputClassName={'md:text-center'}
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'names',
                                value: {...names, en: text},
                            })
                        }
                    />
                </div>

                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Sub Title (Korean)</Text>
                    <UnderLineInput
                        inputClassName={'md:text-center'}
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'subtitles',
                                value: {...subtitles, ko: text},
                            })
                        }
                    />
                </div>
                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Sub Title (English)</Text>
                    <UnderLineInput
                        inputClassName={'md:text-center'}
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'subtitles',
                                value: {...subtitles, en: text},
                            })
                        }
                    />
                </div>

                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Event Thumbnail (Korean)</Text>
                    <div
                        onClick={() => thumbnailKoRef?.current?.click()}
                        className={
                            'border border-line02 rounded-[10px] overflow-hidden w-full min-h-[50px] max-h-[60px] mt-[10px] cursor-pointer md:max-h-[100%] md:min-h-0'
                        }>
                        {thumbnails?.ko && <WizImage src={`${thumbnails.ko}?type=webp&width=1920`} />}
                    </div>
                    <input
                        type={'file'}
                        onChange={e => onChangeThumbnail(e, 'ko')}
                        ref={thumbnailKoRef}
                        className={'hidden'}
                    />
                </div>
                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Event Thumbnail (English)</Text>
                    <div
                        onClick={() => thumbnailEnRef?.current?.click()}
                        className={
                            'border border-line02 rounded-[10px] overflow-hidden w-full min-h-[50px] max-h-[60px] mt-[10px] cursor-pointer md:min-h-[35px] sm:min-h-[59px]'
                        }>
                        {thumbnails?.en && <WizImage src={`${thumbnails.en}?type=webp&width=1920`} />}
                    </div>
                    <input
                        type={'file'}
                        onChange={e => onChangeThumbnail(e, 'en')}
                        ref={thumbnailEnRef}
                        className={'hidden'}
                    />
                </div>

                <div className={'col-span-2 md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Icon</Text>
                    <div
                        onClick={() => iconImageRef?.current?.click()}
                        className={
                            'border border-line02 rounded-[10px] overflow-hidden w-[80px] h-[80px] mt-[10px] cursor-pointer md:mx-auto  md:min-h-[35px] sm:min-h-[59px]'
                        }>
                        {icon && <WizImage src={icon} />}
                    </div>
                    <input
                        type={'file'}
                        onChange={e => {
                            onChangeIcon(e)
                        }}
                        ref={iconImageRef}
                        className={'hidden'}
                    />
                </div>

                <div
                    className={
                        'col-span-2 flex gap-[30px] justify-between md:flex-wrap md:items-center md:text-center md:justify-center'
                    }>
                    <div className={'md:space-y-[5px]'}>
                        <Text className={'text-body3 text-font02'}>Start At</Text>
                        <DateInput
                            onChange={e => dispatch({type: 'field_update', field: 'start_at', value: e.target.value})}
                        />
                    </div>
                    <div className={'md:space-y-[5px]'}>
                        <Text className={'text-body3 text-font02'}>End At</Text>
                        <DateInput
                            onChange={e => dispatch({type: 'field_update', field: 'end_at', value: e.target.value})}
                        />
                    </div>
                    <div className={'md:space-y-[5px]'}>
                        <Text className={'text-body3 text-font02'}>Register By</Text>
                        <DateInput
                            onChange={e =>
                                dispatch({
                                    type: 'field_update',
                                    field: 'register_by',
                                    value: e.target.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Start Url (Korean)</Text>
                    <UnderLineInput
                        inputClassName={'md:text-center'}
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'start_urls',
                                value: {...start_urls, ko: text},
                            })
                        }
                    />
                </div>
                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Start Url (English)</Text>
                    <UnderLineInput
                        inputClassName={'md:text-center'}
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'start_urls',
                                value: {...start_urls, en: text},
                            })
                        }
                    />
                </div>

                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Prize Pool (Korean)</Text>
                    <UnderLineInput
                        inputClassName={'md:text-center'}
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'prize_pools',
                                value: {...prize_pools, ko: text},
                            })
                        }
                    />
                </div>
                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Prize Pool (English)</Text>
                    <UnderLineInput
                        inputClassName={'md:text-center'}
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'prize_pools',
                                value: {...prize_pools, en: text},
                            })
                        }
                    />
                </div>

                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>League Join Min Balance</Text>
                    <UnderLineInput
                        inputClassName={'md:text-center'}
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'min_balance',
                                value: text,
                            })
                        }
                    />
                </div>
                <div className={'sm:space-y-[5px]'}>
                    <Text className={'hidden sm:block text-body3 text-font02'}>Min Balance Currency</Text>
                    <WizSelectButton
                        data={currentList}
                        onChange={item => {
                            setBalanceCurrent(item)
                        }}
                        activeValue={balanceCurrent}
                        className={'sm:mx-auto'}
                    />
                </div>

                <div className={'space-y-[5px] md:space-y-[10px]'}>
                    <Text className={'text-body3 text-font02'}>Exchange</Text>
                    <div className={'flex space-x-[10px]'}>
                        <WizSelect
                            optionKey="exchange"
                            value={getValueFromId('exchange', exchange)}
                            onChange={id => {
                                dispatch({
                                    type: 'field_update',
                                    field: 'exchange',
                                    value: id,
                                })
                            }}
                            className={'md:mx-auto '}
                        />
                    </div>
                </div>

                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Rank</Text>
                    <UnderLineInput
                        inputClassName={'w-[120px] md:text-center'}
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'rank',
                                value: text,
                            })
                        }
                    />
                </div>

                <div>
                    <Text className={'text-body3 text-font02'}>WEB Join Button Color</Text>
                    <div className={'mt-[5px]'}>
                        <WizSelectButton
                            data={themeColorList}
                            onChange={item => {
                                setThemeColor(item)
                                dispatch({
                                    type: 'field_update',
                                    field: 'meta',
                                    value: {...meta, theme_color: item?.id},
                                })
                            }}
                            activeValue={themeColor}
                            className={'sm:mx-auto'}
                        />
                    </div>
                    <div
                        className={`flex items-center gap-x-[15px] mt-[20px] md:space-y-[5px]  ${
                            themeColor?.id ? 'hidden' : 'block'
                        }`}>
                        <UnderLineInput
                            inputClassName={'w-[150px] md:text-center'}
                            onChanged={text =>
                                dispatch({
                                    type: 'field_update',
                                    field: 'meta',
                                    value: {...meta, theme_color: text},
                                })
                            }
                        />
                        <div
                            style={{backgroundColor: meta?.theme_color || '#FFFFFF'}}
                            className={'w-[24px] h-[24px] border rounded-[5px]'}
                        />
                    </div>
                </div>

                <div className={'md:space-y-[5px]'}>
                    <Text className={'text-body3 text-font02'}>Active Number</Text>
                    <UnderLineInput
                        inputClassName={'w-[150px] md:text-center'}
                        value={show}
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'show',
                                value: Number(text),
                            })
                        }
                    />
                </div>

                <div className={'lg:col-span-2 lg:text-center'}>
                    <Text className={'text-body3 text-font02'}>League Banner (PC)</Text>
                    <div
                        onClick={() => leagueBannerPcRef?.current?.click()}
                        className={
                            'border border-line02 rounded-[10px] overflow-hidden w-[400px] min-h-[83.6px] sm:w-[251px] sm:min-h-[52px] mt-[10px] cursor-pointer lg:mx-auto'
                        }>
                        {meta?.banner_pc && <WizImage src={`${meta?.banner_pc}?type=webp&width=1920`} />}
                    </div>
                    <input
                        type={'file'}
                        onChange={e => onChangeLeagueBanner(e, 'pc')}
                        ref={leagueBannerPcRef}
                        className={'hidden'}
                    />
                </div>
                <div className={' lg:text-center lg:col-span-2'}>
                    <Text className={'text-body3 text-font02'}>League Banner (Mobile)</Text>
                    <div
                        onClick={() => leagueBannerMoRef?.current?.click()}
                        className={
                            'border border-line02 rounded-[10px] overflow-hidden w-[400px] min-h-[217.6px] sm:w-[251px] sm:min-h-[135px] mt-[10px] cursor-pointer lg:mx-auto'
                        }>
                        {meta?.banner_mobile && <WizImage src={`${meta?.banner_mobile}?type=webp&width=1920`} />}
                    </div>
                    <input
                        type={'file'}
                        onChange={e => onChangeLeagueBanner(e, 'mo')}
                        ref={leagueBannerMoRef}
                        className={'hidden'}
                    />
                </div>

                <div
                    className={
                        'grid grid-cols-2 col-span-2 gap-y-[30px] md:block md:space-x-0 md:space-y-[30px] md:w-[50%] md:mx-auto md:break-keep sm:w-[75%]'
                    }>
                    <div className={'space-y-[5px] relative md:space-y-[10px]'}>
                        <Text className={'text-body3 text-font02'}>User Join</Text>
                        <div className={'flex space-x-[10px] md:space-x-0 md:mt-[7px]'}>
                            <WizSelectButton
                                data={userJoinList}
                                onChange={e => {
                                    dispatch({
                                        type: 'field_update',
                                        field: 'can_join',
                                        value: userJoinList?.find(item => item.id === e.id).id,
                                    })
                                }}
                                activeValue={userJoinList?.find(item => item.id === can_join)}
                                className={'md:mx-auto'}
                            />
                        </div>
                        <div className={'space-y-[5px] md:mt-[20px]'}>
                            <Text className={'text-body_comm text-font03'}>
                                * True: 유저가 리그에 참가하기 버튼을 눌러 참가할 수 있습니다.
                            </Text>
                            <Text className={'text-body_comm text-font03'}>
                                * False: 유저가 리그에 참가하기 버튼을 눌러 참가할 수 없습니다.
                            </Text>
                        </div>
                    </div>

                    <div className={'space-y-[5px] relative md:space-y-[10px]'}>
                        <Text className={'text-body3 text-font02'}>Is Active</Text>
                        <div className={'flex space-x-[10px] md:space-x-0 md:mt-[7px]'}>
                            <WizSelectButton
                                data={isActiveList}
                                onChange={e => {
                                    dispatch({
                                        type: 'field_update',
                                        field: 'is_active',
                                        value: isActiveList?.find(item => item.id === e.id).id,
                                    })
                                }}
                                activeValue={isActiveList?.find(item => item.id === is_active)}
                                className={'md:mx-auto'}
                            />
                        </div>
                        <div className={'space-y-[5px]'}>
                            <Text className={'text-body_comm text-font03'}>
                                * True: 대회가 리그 페이지 메인에 노출됩니다.
                            </Text>
                            <Text className={'text-body_comm text-font03'}>
                                * False: 대회가 리그 페이지 메인에 노출되지 않습니다. 하지만 리그 리스트에서는
                                노출됩니다.
                            </Text>
                        </div>
                    </div>

                    <div className={'space-y-[5px] relative md:space-y-[10px]'}>
                        <Text className={'text-body3 text-font02'}>Auto Join</Text>
                        <div className={'flex space-x-[10px] md:space-x-0 md:mt-[7px]'}>
                            <WizSelectButton
                                data={autoJoinList}
                                onChange={e => {
                                    dispatch({
                                        type: 'field_update',
                                        field: 'autojoin',
                                        value: autoJoinList?.find(item => item.id === e.id).id,
                                    })
                                }}
                                activeValue={autoJoinList?.find(item => item.id === autojoin)}
                                className={'md:mx-auto'}
                            />
                        </div>
                        <div className={'space-y-[5px]'}>
                            <Text className={'text-body_comm text-font03'}>
                                * Auto: 리그 생성시 자동으로 참여 조건에 해당되는 유저들이 리그에 참여됩니다.
                            </Text>
                            <Text className={'text-body_comm text-font03'}>
                                * Manual: 리그 생성시 유저가 자동으로 참여되지 않습니다.
                            </Text>
                        </div>
                    </div>

                    <div className={'space-y-[5px] relative md:space-y-[10px]'}>
                        <Text className={'text-body3 text-font02'}>Promotion</Text>
                        <div className={'flex space-x-[10px] md:space-x-0 md:mt-[7px]'}>
                            <WizSelectButton
                                data={promotionList}
                                onChange={e => {
                                    dispatch({
                                        type: 'field_update',
                                        field: 'promote',
                                        value: promotionList?.find(item => item.id === e.id).id,
                                    })
                                }}
                                activeValue={promotionList?.find(item => item.id === promote)}
                                className={'md:mx-auto'}
                            />
                        </div>
                        <div className={'space-y-[5px]'}>
                            <Text className={'text-body_comm text-font03'}>
                                * True: 해당 리그를 프로모션 리그로 설정합니다.
                            </Text>
                            <Text className={'text-body_comm text-font03'}>
                                * False: 해당 리그를 프로모션 리그가 되지 않게 설정합니다.
                            </Text>
                        </div>
                    </div>
                </div>

                <div className={'col-span-2 md:break-keep md:w-[75%] md:mx-auto md:space-y-[20px]'}>
                    <Text className={'text-body3 text-font03'}>
                        * User Join을 True로 하고, Auto Join을 False로 하면 유저가 수동으로 참가하기 버튼을 눌러야
                        리그에 참여됩니다.
                    </Text>
                    <Text className={'text-body3 text-font03'}>
                        * User Join을 False로 하고, Auto Join을 True로 한다면 유저에게 참가하기 버튼은 보여지지 않지만,
                        자동으로 리그에 참가되니 실수를 주의해야합니다.
                    </Text>
                </div>

                <div className={'col-span-2 text-center mt-[30px]'}>
                    <WizButton
                        type={'blue'}
                        size={'big'}
                        text={'Create League'}
                        onClick={() => onClickCreateLeague()}
                    />
                </div>
            </div>
        </PageLayout>
    )
}

export default LeagueCreatePage
